import { useMutationState } from '@tanstack/react-query';
import { useChatbot } from './useChatbot.js';
import { mutationKeyNotepadStateUpdate } from '../../resource-detail/mutations/useMutationNotepadStateUpdate.js';

const useActiveContextFileNotepadStatePending = () => {
  const { ephemeralContext: activeContext } = useChatbot();
  const notepadStateStatuses = useMutationState({
    filters: {
      mutationKey: mutationKeyNotepadStateUpdate(activeContext?.type === "resource" ? activeContext.value : void 0)
    },
    select: (mutation) => mutation.state.status
  });
  const isPendingNotepadState = notepadStateStatuses.some((status) => status === "pending");
  return isPendingNotepadState;
};

export { useActiveContextFileNotepadStatePending };
//# sourceMappingURL=useActiveContextFileNotepadStatePending.js.map
